import React from 'react';
import { useSelector } from 'react-redux';
import { Pencil, RotateCcw, Trash2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/Button';
import { DetailRow } from '@/components/ui/DetailSection';
import Bar from '@/components/elements/Bar';
import { Manufacturer } from '../hooks/useManufacturer';

type ManufacturerDetailProps = {
  data: Manufacturer;
  onEdit: () => void;
  onToggleActive: () => void;
};

const ManufacturerDetail = ({ data, onEdit, onToggleActive }: ManufacturerDetailProps) => {
  const permission = useSelector((state: any) => state.auth.pagePermission);

  return (
    <div className="flex-1 min-w-0 overflow-y-auto">
      <Bar
        text={data.title}
        content={
          permission === 2
            ? [
                <Button
                  key="toggle"
                  variant="ghost"
                  size="icon-sm"
                  onClick={onToggleActive}
                  data-testid="manufacturer-detail-toggle-active-btn"
                >
                  {data.is_active ? <Trash2 /> : <RotateCcw />}
                </Button>,
                <Button
                  key="edit"
                  variant="ghost"
                  size="icon-sm"
                  onClick={onEdit}
                  data-testid="manufacturer-detail-edit-btn"
                >
                  <Pencil />
                </Button>,
              ]
            : undefined
        }
      />
      <div className="p-6 space-y-3">
        <DetailRow label="Název" value={data.title} />
        <DetailRow
          label="Web"
          value={
            data.url ? (
              <a
                href={data.url}
                target="_blank"
                rel="noreferrer"
                className="text-primary-600 hover:underline"
                data-testid="manufacturer-detail-url-link"
              >
                {data.url}
              </a>
            ) : (
              '—'
            )
          }
        />
        <DetailRow
          label="Stav"
          value={
            <Badge variant={data.is_active ? 'success' : 'default'} size="sm">
              {data.is_active ? 'Aktivní' : 'Neaktivní'}
            </Badge>
          }
        />
      </div>
    </div>
  );
};

export default ManufacturerDetail;
